/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurringmonth1Inputs */

const en_recurringmonth1 = /** @type {(inputs: Recurringmonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`month`)
};

const de_recurringmonth1 = /** @type {(inputs: Recurringmonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat`)
};

/**
* | output |
* | --- |
* | "month" |
*
* @param {Recurringmonth1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const recurringmonth1 = /** @type {((inputs?: Recurringmonth1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurringmonth1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurringmonth1(inputs)
	return de_recurringmonth1(inputs)
});
export { recurringmonth1 as "recurringMonth" }